<template>
  <div
    ref="filter-more"
    id="filter-more"
    class="modal modal-right fade modal-more-filters"
    tabindex="-1"
    role="dialog"
    aria-labelledby="filter"
  >
    <div
      class="modal-dialog"
      role="document"
      style="width: 360px;"
    >
      <div
        class="modal-content"
        ref="section"
      >
        <div class="modal-header bg-dark">
          <h6 class="modal-title">
            {{ $t("More Filters") }}
          </h6>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body p-0 pb-5 px-0">
          <div class="card-header header-elements-inline border-0 shadow-none card-header-main p-0">
            <div
              @click="toggleOption('sales_channel')"
              aria-expanded="false"
              class="font-weight-semibold cursor-pointer collapsed w-100 d-flex justify-content-between py-2 px-3"
              data-toggle="collapse"
              data-target="#collapse-sales_channel"
            >
              <div>{{ $t("Channels") }}</div>
              <div class="header-elements">
                <div class="list-icons">
                  <a
                    :class="['list-icons-item', {'rotate-180': options.sales_channel}]"
                    data-action="collapse"
                  />
                </div>
              </div>
            </div>
          </div>
          <div
            class="collapse ui-filter-list card-body px-0"
            id="collapse-sales_channel"
          >
            <div class="filter-option">
              <div class="form-group">
                <div
                  class="form-check"
                  v-for="(channelsType, index) in groupChannelType(salesChannel)"
                  :key="channelsType.type.replace(/ /g, '')"
                >
                  <div class="card-header header-elements-inline border-0 shadow-none p-0">
                    <div
                      @click="rotateChannelType(channelsType.type.replace(/ /g, ''))"
                      name="channelsType"
                      aria-expanded="false"
                      class="font-weight-semibold own-rotate cursor-pointer collapsed w-100 d-flex justify-content-between py-0 px-3"
                      data-toggle="collapse"
                      :data-target="'#collapse-channels-type-'+channelsType.type.replace(/ /g, '')"
                    >
                      <div>
                        <img
                          :src="channelsType.logo"
                          class="mr-2 rounded"
                          width="20"
                        >
                        {{ channelsType.type }}
                      </div>
                      <div class="header-elements">
                        <div class="list-icons">
                          <a
                            :class="['list-icons-item']"
                            :id="'list-icons_'+channelsType.type.replace(/ /g, '')"
                            data-action="collapse"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="collapse ui-filter-list card-body py-0 px-4"
                    :id="'collapse-channels-type-'+channelsType.type.replace(/ /g, '')"
                  >
                    <div class="filter-option">
                      <div 
                        class="form-group"
                        :class="{'pt-2': index == 0}"
                      >
                        <div
                          class="form-check"
                          v-for="dataChannels in salesChannel"
                          :key="dataChannels.id"
                        >
                          <label
                            class="form-check-label"
                            v-if="dataChannels.type.replace(/ /g, '') == channelsType.type.replace(/ /g, '')"
                          >
                            <div class="uniform-checker ">
                              <span :class="[(dataFilter.sales_channel.includes(dataChannels.id) ? 'checked' : '')]">
                                <input
                                  type="checkbox"
                                  class="custom-control-input"
                                  :value="dataChannels.id"
                                  :id="'pay-'+dataChannels.id"
                                  v-model="dataFilter.sales_channel"
                                >
                              </span>
                            </div>
                            <div>
                              {{ dataChannels.name }}
                            </div>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="clear px-3">
                <a
                  href="javascript:void(0)"
                  class="text-secondary"
                  @click="clearFilter('sales_channel')"
                >{{ $t("Clear") }}</a>
              </div>
            </div>
          </div>
          <div class="card-header header-elements-inline border-0 shadow-none card-header-main p-0">
            <div
              @click="toggleOption('product')"
              aria-expanded="false"
              class="font-weight-semibold cursor-pointer collapsed w-100 d-flex justify-content-between py-2 px-3"
              data-toggle="collapse"
              data-target="#collapse-product"
            >
              <div>{{ $t("Product") }}</div>
              <div class="header-elements">
                <div class="list-icons">
                  <a
                    :class="['list-icons-item', {'rotate-180': options.product}]"
                    data-action="collapse"
                  />
                </div>
              </div>
            </div>
          </div>
          <div
            class="collapse ui-filter-list card-body px-4"
            id="collapse-product"
          >
            <div class="filter-option">
              <div class="form-group">
                <div 
                  id="product-select-search" 
                  class="mt-2"
                >
                  <Select2
                    id="filterProduct"
                    name="product_filter"
                    v-model="dataFilter.product"
                    :options="optionProduct"
                    :settings="settingOptionProduct"
                    :placeholder="$t('Enter product name...')"
                  />
                </div>
              </div>
              <div class="clear">
                <a
                  href="javascript:void(0)"
                  class="text-secondary"
                  @click="clearFilter('product')"
                >{{ $t("Clear") }}</a>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer fixed-bottom bg-light border-top d-flex justify-content-between py-2 px-3">
          <button
            type="button"
            class="btn btn-light"
            @click="clearFilter('all')"
          >
            {{ $t('Clear all filters') }}
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="doneFilter()"
            data-dismiss="modal"
          >
            {{ $t('Done') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Api from '@/services/endpoint/tenant.service'
import Select2 from "v-select2-component"

export default {
  name: "FilterMore",
  props: {
    filter: {
      type: Object,
      default() {
        return {
          sales_channel: [],
        }
      }
    },
  },
  components: {
    Select2
  },
  data() {
    let vm = this;
    return {
      options: {
        sales_channel: false,
        product: false,
      },
      dataFilter: initialFilter(),
      optionProduct: [],
      settingOptionProduct: {
        minimumResultsForSearch: Infinity,
        multiple: true,
        tags: false,
        templateResult: this.formatSelect2Products,
        templateSelection: this.formatSelect2ProductTemplate,
        maximumSelectionLength: 1,
        language: {
          inputTooShort: function(e){
            let text = vm.$t('Please enter {minimum} or more characters');
            let textFull = text.replace("{minimum}", e.minimum);
            return textFull;
          },
          loadingMore:function (e) {
            return '<i class="fa fa-spinner fa-spin"></i>';
          },
          noResults: this.noResults,
          maximumSelected: function (e) {
            var text = vm.$t('_Tags.You can only select')+ ' ' + e.maximum + ' ' + vm.$t('_Tags.items');
            return text;
          },
        },
        ajax: {
          cache: true,
          delay: 250,
          beforeSend: function (request) {
            request.setRequestHeader("Authorization", 'Bearer ' + Api.AUTH.TOKEN);
          },
          url: Api.AUTH.URL + Api.URL.SHIPMENT_GETPRODUCT,
          data: function (params) {
            var query = {
              q: params.term,
              status: '1,3',
              product_type_id: '1,2,3',
              show_variant: 1,
              sort: 'type|desc'
            }
            return query;
          },
          processResults: function (productsOption) {
            let products = productsOption.data;
            return {
              results: products
            }
          }
        },
      },
    }
  },
  mounted() {
    
  },
  computed: {
    salesChannel: function() {
      return this.filter.sales_channel ? this.filter.sales_channel : [];
    }
  },
  methods: {
    toggleOption(key) {
      if (key == 'sales_channel') {
        (this.options.sales_channel) ? this.options.sales_channel = false: this.options.sales_channel = true;
      } else if (key == 'product') {
        (this.options.product) ? this.options.product = false: this.options.product = true;
      }
    },
    clearFilter(key) {
      if (key == 'sales_channel') {
        this.dataFilter.sales_channel = [];
      } else if (key == 'product') {
        this.dataFilter.product = [];
      } else {
        this.dataFilter = initialFilter();
      }
    },
    doneFilter() {
      this.$emit('onSubmit', this.dataFilter);
      $("#filter-more").modal('hide');
    },
    groupChannelType(Channel) {
      return Channel.length > 0 ? [...new Map(Channel.map((item) => [item["type"], item])).values()] : [];
    },
    rotateChannelType(channelTypeID) {
      if ($('#list-icons_'+channelTypeID).hasClass('rotate-180')) {
        $('#list-icons_'+channelTypeID).removeClass('rotate-180');
      } else { 
        $('#list-icons_'+channelTypeID).addClass('rotate-180');
      }
    },
    formatSelect2Products: function (product) {
      let imgSource = this.$storeIndex.getImageSrc('integration/default');
      let integrationName = this.$t("Manual Product")
      if(product.integration != null){
        imgSource = product.integration.integration_type.logo;
        integrationName = product.integration.name;
        if(product.integration.name.length > 10){
          integrationName = product.integration.name.substring(0, 8).trim() + '...';
        }
      }
      if (!product.id) {
        return this.$t("Searching...");
      }

      let image = '<div class="mr-3"><img src="' + this.$storeIndex.getImageGobalAssets(product.id) + '" class="thumb40 rounded"></div>';;
      if (this.$storeIndex.isset(() => product.product_media_first.media.image_url)) {
        image = '<div class="mr-3"><img src="' + product.product_media_first.media.image_url + '" class="thumb40 rounded" ></div>';
      } else {
        try {
          let productMedia = product.product_media[product.product_media.length - 1].media.image_url;
          image = '<div class="mr-3"><img src="' + productMedia + '" class="thumb40 rounded"></div>';
        }
        catch(err) {}
      }

      let select2Product = $(
        `<div class="align-items-center d-flex justify-content-between">
          <div class="col-2 mr-1">
            ${image}
          </div>
          <div class="col-10">
            <div class="font-weight-semibold item-name d-flex">${product.name}</div>
            <div class="font-weight-semibold item-name d-flex">
              <span>SKU:</span>
              <span class="sku-text-muted ml-1">${product.sku ? product.sku : "-"}</span>
            </div>
            <div class="d-flex">
              <img class="thumb20 rounded mr-1" src="${imgSource}">
              <span class='mr-2'>${integrationName}</span>
            </div>
          </div>
        </div>`
      );

      return select2Product;
    },
    formatSelect2ProductTemplate: function (option) {
      let imageSrc = this.$storeIndex.getImageGobalAssets(option.id)
      if(option.product_media_first != null ){
        imageSrc = option.product_media_first.media.image_url
      }
      let txt = `
        <div class="list-item d-flex templateselect" style="background: #EEEEEE;">
          <div class="" style="">
            <img src="${imageSrc}" class="thumb25 mr-2">
          </div>
          <div class="item-content">
            <div class="item-name" style="color: #515151;padding-top: 5px;">
              ${option.name}
            </div>
          </div>
        </div>`
      return $(txt);
    },
  }
}

function initialFilter() {
  return {
    sales_channel: [],
    product: []
  }
}
</script>
<style>
.card-header-main .font-weight-semibold[data-toggle="collapse"][aria-expanded="true"] {
  background-color: #FAFAFA;
}
.thumb40{
  width:40px;
  height:40px;
  object-fit: cover;
}
.thumb20 {
  width:20px;
  height:20px;
  object-fit: cover;
}
</style>


// WEBPACK FOOTER //
// src/components/tenancy/admin/report/product/BestsellerFiltersMore.vue